import { Smile } from 'lucide-react'

import { EmojiPickerPopover } from '@/components/lemmala-design-system/emoji-picker/emoji-picker-popover'

import { COMMENT_LABELS } from './labels'

type AddReactionButtonProps = {
  onEmojiSelect: (emoji: string) => void
  frequentEmojis?: string[]
}

export const AddReactionButton = ({ onEmojiSelect, frequentEmojis }: AddReactionButtonProps) => (
  <EmojiPickerPopover
    onEmojiSelect={onEmojiSelect}
    frequentEmojis={frequentEmojis}
    trigger={
      <button
        type='button'
        aria-label={COMMENT_LABELS.addReaction}
        className='flex size-6 items-center justify-center rounded text-main-foreground-tertiary hover:text-main-foreground-primary'
      >
        <Smile className='size-4' />
      </button>
    }
  />
)
